<template>
  <div class="fixed bottom-0 w-full bg-[#2555FF] flex justify-between items-center pl-1 pr-1 p-1 shadow-md text-white">
    <div class="flex items-center">
      <div class="relative w-14 h-10 flex items-center justify-center">
        <svg viewBox="0 0 57 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_283_209)">
          <rect x="11" y="10.3455" width="34.3091" height="34.3091" rx="8.33221" fill="#1D3FBA"/>
          <g clip-path="url(#clip0_283_209)">
          <path d="M26.6378 39.1383C26.5247 39.1383 26.4107 39.118 26.3013 39.0739C25.8922 38.913 25.654 38.4846 25.734 38.0525L27.2308 29.9168H23.2434C22.9014 29.9168 22.587 29.7265 22.4288 29.4231C22.2698 29.1197 22.2927 28.7538 22.4877 28.4724L30.1259 17.4674C30.3723 17.1125 30.8339 16.9792 31.2274 17.1401C31.6264 17.3028 31.859 17.7202 31.7873 18.144L30.5746 25.3474H34.2761C34.6116 25.3474 34.9205 25.5304 35.0824 25.8255C35.2442 26.1207 35.2313 26.4792 35.0511 26.7624L27.4128 38.7144C27.24 38.9847 26.9439 39.1383 26.6378 39.1383Z" fill="#ECF8FF"/>
          </g>
          <g clip-path="url(#clip1_283_209)">
          <path d="M30.5025 25.2021L27.0185 30.328L24.6958 43.7835L36.3091 25.2021H30.5025Z" fill="#25FF7C"/>
          </g>
          </g>
          <defs>
          <filter id="filter0_d_283_209" x="-0.167274" y="-0.821815" width="56.6436" height="56.6436" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="5.58364"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.145833 0 0 0 0 0.33375 0 0 0 0 1 0 0 0 1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_283_209"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_283_209" result="shape"/>
          </filter>
          <clipPath id="clip0_283_209">
          <rect width="22.0653" height="22.0653" fill="white" transform="translate(17.7271 17.0728)"/>
          </clipPath>
          <clipPath id="clip1_283_209">
          <rect width="22.0653" height="22.0653" fill="white" transform="translate(17.7271 17.0728)"/>
          </clipPath>
          </defs>
        </svg>

        <div :class="isActive ? 'bg-green-400' : 'bg-red-400'" class="absolute top-0 right-1 w-3 h-3 rounded-full border-2 border-white"></div>
      </div>
      <span class="font-inter text-xs bg-[#0A1C592B] p-1 rounded font-semibold leading-tight text-left mr-2 h-[22px]  pt-[6px] px-2">://MODO_HACK</span>
      <div :class="notificationsEnabled ? 'bg-green-flashing text-[#25FF7C]' : 'bg-red-500'" class="flex items-center font-inter text-xs p-1 px-2 rounded font-semibold leading-tight text-left mr-2 h-[22px] pt-[3px]">
        <!-- Ícone de notificação ao invés do check -->
        <svg class="" width="11" height="12" viewBox="0 0 11 12" :fill="notificationsEnabled ? '#25FF7C' : '#ffffff'" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.5 1C3.84315 1 2.5 2.34315 2.5 4V7L1.5 8V8.5H9.5V8L8.5 7V4C8.5 2.34315 7.15685 1 5.5 1ZM4.5 9.5H6.5C6.5 10.0523 6.05228 10.5 5.5 10.5C4.94772 10.5 4.5 10.0523 4.5 9.5Z"/>
        </svg>
        <span class="ml-1">notificações</span>
      </div>
    </div>
    <div class="flex items-center mr-2">
      <div class="flex items-center bg-[#1D2B5B4F] p-1 rounded-full mr-2">
        <div @click="toggleNotifications"  class="relative bg-gray-800 rounded-full w-10 h-5 flex items-center cursor-pointer mr-1">
          <div :class="notificationsEnabled ? 'bg-green-400 translate-x-full' : 'bg-red-400'" class="w-5 h-5 rounded-full transform transition-transform"></div>
        </div>
        <span class="mr-2 text-xs mt-[2px]">{{ notificationsEnabled ? 'Ligado' : 'Desligado' }}</span>
      </div>
      <svg @click="handleClick" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4939 0.883C10.1702 0.75 9.75891 0.75 8.93729 0.75C8.11566 0.75 7.70529 0.75 7.38066 0.883C6.94968 1.05993 6.60662 1.40079 6.42691 1.83062C6.34466 2.02575 6.31316 2.25412 6.30004 2.58575C6.2942 2.82603 6.22718 3.06085 6.1053 3.268C5.98343 3.47516 5.81073 3.64781 5.60354 3.76963C5.39244 3.88697 5.15514 3.94913 4.91362 3.95035C4.67211 3.95157 4.43419 3.89182 4.22191 3.77663C3.92616 3.62088 3.71179 3.53513 3.50004 3.50712C3.03677 3.4463 2.56823 3.57082 2.19629 3.85362C1.91804 4.06537 1.71241 4.41887 1.30204 5.125C0.890788 5.83112 0.686038 6.18375 0.639663 6.52937C0.578413 6.98962 0.704413 7.45512 0.989663 7.8235C1.11916 7.9915 1.30204 8.13237 1.58466 8.30912C2.00204 8.569 2.26979 9.01175 2.26979 9.5C2.26979 9.98825 2.00204 10.431 1.58554 10.69C1.30204 10.8676 1.11916 11.0085 0.988788 11.1765C0.847985 11.3584 0.744636 11.5665 0.684712 11.7886C0.624787 12.0107 0.609476 12.2425 0.639663 12.4706C0.686038 12.8154 0.890788 13.1689 1.30204 13.875C1.71329 14.5811 1.91804 14.9337 2.19629 15.1464C2.56729 15.429 3.03629 15.5533 3.50004 15.4929C3.71179 15.4649 3.92616 15.3791 4.22191 15.2234C4.4343 15.108 4.67238 15.0482 4.91406 15.0494C5.15575 15.0506 5.39321 15.1129 5.60441 15.2304C6.02966 15.4754 6.28166 15.926 6.30004 16.4143C6.31316 16.7468 6.34466 16.9742 6.42691 17.1694C6.60541 17.5981 6.94841 17.9394 7.38066 18.117C7.70441 18.25 8.11566 18.25 8.93729 18.25C9.75891 18.25 10.1702 18.25 10.4939 18.117C10.9249 17.9401 11.268 17.5992 11.4477 17.1694C11.5299 16.9742 11.5614 16.7468 11.5745 16.4143C11.592 15.926 11.8449 15.4745 12.271 15.2304C12.4821 15.113 12.7194 15.0509 12.961 15.0497C13.2025 15.0484 13.4404 15.1082 13.6527 15.2234C13.9484 15.3791 14.1628 15.4649 14.3745 15.4929C14.8383 15.5541 15.3073 15.429 15.6783 15.1464C15.9565 14.9346 16.1622 14.5811 16.5725 13.875C16.9838 13.1689 17.1885 12.8163 17.2349 12.4706C17.265 12.2425 17.2495 12.0107 17.1894 11.7885C17.1294 11.5664 17.0259 11.3584 16.8849 11.1765C16.7554 11.0085 16.5725 10.8676 16.2899 10.6909C15.8725 10.431 15.6048 9.98825 15.6048 9.5C15.6048 9.01175 15.8725 8.569 16.289 8.31C16.5725 8.13238 16.7554 7.9915 16.8858 7.8235C17.0266 7.64155 17.1299 7.4335 17.1899 7.21138C17.2498 6.98925 17.2651 6.75745 17.2349 6.52937C17.1885 6.18462 16.9838 5.83112 16.5725 5.125C16.1613 4.41887 15.9565 4.06625 15.6783 3.85362C15.3063 3.57082 14.8378 3.4463 14.3745 3.50712C14.1628 3.53513 13.9484 3.62088 13.6527 3.77663C13.4403 3.89198 13.2022 3.95181 12.9605 3.95059C12.7188 3.94937 12.4814 3.88712 12.2702 3.76963C12.0631 3.6477 11.8906 3.47501 11.7689 3.26786C11.6472 3.06071 11.5803 2.82594 11.5745 2.58575C11.5614 2.25325 11.5299 2.02575 11.4477 1.83062C11.3587 1.61777 11.2287 1.42452 11.0651 1.26193C10.9014 1.09933 10.7073 0.970568 10.4939 0.883ZM8.93729 12.125C10.3985 12.125 11.5824 10.9499 11.5824 9.5C11.5824 8.05013 10.3977 6.875 8.93729 6.875C7.47604 6.875 6.29216 8.05013 6.29216 9.5C6.29216 10.9499 7.47691 12.125 8.93729 12.125Z" fill="#D7E0FF"/>
      </svg>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterNotification',
  props: ['isActive', 'notificationsEnabled'],
  methods: {
    handleClick() {
      this.$emit('notification-click');
    },
    toggleActive() {
      this.$emit('update-checked', { isActive: !this.isActive });
    },
    toggleNotifications() {
      this.$emit('toggle-notifications', !this.notificationsEnabled);
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@600&display=swap');

.font-inter {
  font-family: 'Inter', sans-serif;
}
.text-xs {
  font-size: 7.75px;
  line-height: 9.38px;
}

@keyframes flash {
  0%, 100% { background-color: #25FF7C80; }
  50% { background-color: #25ff7cae; }
}

.bg-green-flashing {
  animation: flash 1s infinite;
}
</style>
